<ion-list class="action-popover" lines="none">
  @for (action of actions; track action.type) {
    <ion-item
      button
      small
      detail="false"
      (click)="onClick(action.type)"
      [disabled]="action.disabled"
      [class.add-to-stack]="action.type === 'add-to-stack'"
      [title]="action?.tooltip ?? action.text"
      >
      <ion-icon slot="start" [name]="action.icon" class="no-pointer-events"></ion-icon>
      @if (showText) {
        <ion-text style="padding-left: 0; white-space: nowrap" slot="start">{{
          action.text
        }}</ion-text>
      }
    </ion-item>
  }
</ion-list>
